import { getTagsByIds } from "app/containers/Features/components/CommonTagSelection/helper";
import { getTicketTypeByIds } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/helper";
import {
  selectTagList,
  selectTicketStatus,
  selectTicketTypes,
} from "app/redux/selector";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  getPriorityByIds,
  getSeverityByIds,
  getStatusById,
} from "../../../../helpers";





export const useGroupMeta = (id:string) => {
  const tagList = useSelector(selectTagList);
  const statusData = useSelector(selectTicketStatus);
  const ticketTypes = useSelector(selectTicketTypes);

  const ticketType = useMemo(
    () => getTicketTypeByIds(ticketTypes, id)?.[0],
    [ticketTypes, id],
  );

  const selectedStatus = useMemo(
    () => getStatusById(statusData,   id),
    [statusData, id],
  );

  const tagsObj = useMemo(
    () => getTagsByIds(tagList, id),
    [tagList, id],
  );

  const selectedPriority = useMemo(
    () => getPriorityByIds( id),
    [id],
  );

  const selectedSeverity = useMemo(
    () => getSeverityByIds(id),
    [id],
  );

  return {
    ticketType,
    selectedStatus,
    tagsObj,
    selectedPriority,
    selectedSeverity,
  };
};
